import { OrderList } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrderList>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const ordersReducer = createReducer<State, Actions>(initialState, {
  [actions.getOrders.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getOrders.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getOrders.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getOrders.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default ordersReducer;
